export const delay = (timeout: number) => {
    return new Promise<void>(resolve => {
        const timeoutId = setTimeout(() => {
            clearTimeout(timeoutId);

            resolve();
        }, timeout);
    });
};
